import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

export type PersonConversation = {
	id: number;
	text: string;
	urn: string;
	short_urn: string;
	type: string;
	subtype: string;
	created: string;
	created_at: string;
	updated: string;
	from_person: number | null;
	from_person_name: string | null;
	json: Record<string, unknown> | null;
};

export type PersonUserConversation = {
	id: number;
	username: string;
	user_first_name?: string;
	user_id: number;
	urn: string;
	short_urn: string;
	person_id: number;
	person_name: string | null;
	conversation_type: number;
	conversation_type_str: string;
	created: string;
	updated: string;
	last_activity_at: string | null;
	json: Record<string, unknown> | null;
	contents: PersonConversation[];
};

export const getPersonConversationsById = (
	id: number
): Promise<DRFListResponseWrapper<PersonUserConversation[]>> => {
	if (!id || typeof id !== "number") {
		throw new Error(
			`getPersonConversationsById called with invalid argument id '${id}'. Expected number`
		);
	}

	return fetch(`/api/v2/persons/${id}/conversations/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const deleteConversation = async (
	personId: number,
	conversationId: number
): Promise<void> => {
	const res = await fetch(
		`/api/v2/persons/${personId}/conversations/${conversationId}/`,
		{
			method: "DELETE",
			headers: getGlobalHeadersAsObject(),
		}
	);
	if (!res.ok) {
		throw new Error(`Failed to delete conversation: ${res.status}`);
	}
};
